module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"login-view-title":"Hoppla! Bitte zuerst einloggen."},"fr":{"login-view-title":"Oups! Veuillez d\u0027abord vous connecter."},"it":{"login-view-title":"Ops! Per favore fare prima il login."}}')
  delete Component.options._Ctor
}
